module.exports = __webpack_public_path__ + "img/green_078.6427b18c.png";